module.exports = __webpack_public_path__ + "img/MUIC_Logo_Eng_Center.9e9c0a01.png";